import { render, staticRenderFns } from "./TeamOperationsEditFooter.vue?vue&type=template&id=cd3628bc&"
import script from "./TeamOperationsEditFooter.vue?vue&type=script&lang=ts&"
export * from "./TeamOperationsEditFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports